import React, { PureComponent } from 'react';
import T from 'prop-types';
import qs from 'query-string';
import { Link } from 'react-router-dom';

import { MODAL_LOGIN, MODAL_SIGNUP, MODAL_FORGOT_PASSWORD, MODAL_RESEND_EMAIL_CONFIRMATION } from '../../constants/app';

import { Container } from './style';

class AuthFormLinks extends PureComponent {
  generateUrl = (modal) => {
    const { pathname, searchParams } = this.props;
    const params = qs.stringify({
      ...searchParams,
      modal,
    });

    return `${pathname}?${params}`;
  };

  render() {
    const { resendConfirmation, signup, password, login } = this.props;

    return (
      <Container>
        {signup && (
          <>
            {"Don't have an account? "}
            <Link to={this.generateUrl(MODAL_SIGNUP)}>Sign up</Link>
            <br />
          </>
        )}
        {login && (
          <>
            {'Already have an account? '}
            <Link to={this.generateUrl(MODAL_LOGIN)}>Log in</Link>
            <br />
          </>
        )}
        {password && (
          <>
            {'Forgotten your password? '}
            <Link to={this.generateUrl(MODAL_FORGOT_PASSWORD)}>Reset Password</Link>
            <br />
          </>
        )}
        {resendConfirmation && (
          <>
            {"Haven't received email confirmation? "}
            <Link to={this.generateUrl(MODAL_RESEND_EMAIL_CONFIRMATION)}>Resend Confirmation Email</Link>
          </>
        )}
      </Container>
    );
  }
}

AuthFormLinks.defaultProps = {
  signup: false,
  login: false,
  password: false,
  resendConfirmation: false,
};

AuthFormLinks.propTypes = {
  searchParams: T.object.isRequired,
  pathname: T.string.isRequired,

  login: T.bool,
  password: T.bool,
  resendConfirmation: T.bool,
  signup: T.bool,
};

export default AuthFormLinks;
